import React from 'react';

const HiddenInput = (props) => {
  const { groupName, name, value } = props;

  return (
    <input
      type="hidden"
      name={`${groupName}[${name}]`}
      value={value || ''} />
  );
};

HiddenInput.defaultProps = {
  groupName: 'parameters',
  name: '',
};

export default HiddenInput;
